import healthcare from '../assest/doctors_herbs.avif'
import education from '../assest/Education_herps.webp'
import retail from '../assest/retail_herps.jpg'
import startup from '../assest/startup_herps.jpg'

const products = [
  {
    id: "Healthcare",
    name: "HealthCare",
    description: "Solutions designed for real people, real businesses, real growth.",
    details: "From admissions to exams—everything in one place. No IT team required.",
    bannerimage:healthcare,
    mission:"Manage appointments, patient records, prescriptions, and medical reports—all in one secure platform.  ",
    prototypename1:" Medical Billing Software",
    prototypename2:"Telemedicine Platforms",
    prototypename3:" Healthcare Mobile Apps",
    prototypeimg:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT3l8O9Z_K99PhbJJQjKyK4xOSS3ZNqF0wnEg&s",
    paragraph:"Manage appointments, records, and reports with confidence and care. ",
    


   
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQC-XoyweBaEokX-tCb9GucRP7nBYrhvTcz9Q&s"
  },
  {
    id: "Education",
    name: "Education",
     mission:"Everything your school needs—from admissions to exams—in one simple platform.",
    description: "Solutions designed for real people, real businesses, real growth.",
    details: "Detailed info about Product B...",
    prototypename1:"E-Learning Platforms",
     prototypename2:" Educational Mobile Apps",
    prototypename3:"Student Information Systems (SIS)",
    bannerimage:education,
     paragraph:"Manage appointments, records, and reports with confidence and care.",
    
  },
    {
    id: "Retail",
    name: "Retail",
      mission:"All-in-One Retail Solution—Track Sales, Stock, and Staff Effortlessly",
    description: "Solutions designed for real people, real businesses, real growth.",
    details: "Detailed info about Product B...",
    bannerimage:retail,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYJ77kdQWUax_AKgqLYUQhdvx-KiiUojVhcQ&s",
     prototypename2:"Inventory & Stock Management Systems",
     prototypename1:"POS (Point of Sale) Solutions",
    prototypename3:" Retail Mobile Apps",
     paragraph:"Manage appointments, records, and reports with confidence and care.   ",
    
  },
  //   {
  //   id: 4,
  //   name: "Professionals",
  //     mission:" Coaches, consultants, or freelancers—manage bookings and clients with ease",
  //   description: "Solutions designed for real people, real businesses, real growth.",
  //   details: "Detailed info about Product B...",
  //   bannerimage:"https://storage.googleapis.com/a1aa/image/b6e9b554-80dd-4573-1b49-fd40a24348d4.jpg",
  //   image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYJ77kdQWUax_AKgqLYUQhdvx-KiiUojVhcQ&s",
  //    prototypename2:"Reporting",
  //    prototypename1:"Appointment",
  //   prototypename3:"Record management",
  //    paragraph:"Manage appointments, records, and reports with confidence and care.   ",
    
  // },
    {
    id: "Professionals",
    name: "Professionals ",
    description: "Solutions designed for real people, real businesses, real growth.",
      mission:"Everything your school needs—from admissions to exams—in one simple platform.",
    details: "Detailed info about Product B...",
    bannerimage:"https://storage.googleapis.com/a1aa/image/b6e9b554-80dd-4573-1b49-fd40a24348d4.jpg",
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYJ77kdQWUax_AKgqLYUQhdvx-KiiUojVhcQ&s",
     prototypename2:" Business Website Development",
     prototypename1:" Project Tracking & Reporting Tools",
    prototypename3:"Client Management Systems (CRM)",
     paragraph:"Manage appointments, records, and reports with confidence and care.   ",
    
  },
    {
    id: "Startups",
    name: "Startups ",
    description: "Solutions designed for real people, real businesses, real growth.",
    details: "Detailed info about Product B...",
      mission:"Got an idea? We’ll help build the MVP with speed and clarity. ",
    bannerimage:startup,
    image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRYJ77kdQWUax_AKgqLYUQhdvx-KiiUojVhcQ&s",
     prototypename2:"Startup Website & Landing Page Development",
     prototypename1:" Startup Branding & UI/UX Design",
    prototypename3:" Custom Web & Mobile App Development",
     paragraph:"Manage appointments, records, and reports with confidence and care. ",
    
  },
 

];

export default products;
